<template>
  <div>
    <div ref="container"></div>
    <InfiniteLoading ref="loader" @infinite="infiniteHandler">
      <span slot="no-more"></span>
      <span slot="no-results"></span>
    </InfiniteLoading>
  </div>
</template>

<script>
import axios from "axios";
import debounce from "lodash.debounce";
import InfiniteLoading from "vue-infinite-loading";

const evt3rdArg = (() => {
  let result = false;
  try {
    const arg = Object.defineProperty({}, "passive", {
      get() {
        result = { passive: true };
      }
    });
    window.addEventListener("testpassive", arg, arg);
    window.remove("testpassive", arg, arg);
  } catch (e) {
    /* */
  }
  return result;
})();

export default {
  components: {
    InfiniteLoading
  },
  props: {
    apiUrl: { required: true, type: String }
  },
  data() {
    return {
      currentPage: 1
    };
  },
  methods: {
    async infiniteHandler($state) {
      const loader = this.$refs.loader;
      try {
        const { headers, data } = await axios.get(this.apiUrl, {
          params: { page: this.currentPage + 1 }
        });
        ++this.currentPage;
        const div = document.createElement('div');
        div.classList.add('add-divider');
        div.insertAdjacentHTML('beforeend', data);
        this.$refs.container.insertAdjacentElement('beforeend', div);
        $state.loaded();
        this.$emit('loaded', div);
        if (headers["x-has-next"] === undefined) $state.complete();
      } catch (e) {
        $state.complete();
        throw e;
      }
    }
  },
  mounted() {
    const loader = this.$refs.loader;
    loader.scrollParent.removeEventListener("scroll", loader.scrollHandler, evt3rdArg);
    loader.scrollHandler = debounce(() => !loader.isLoading && loader.attemptLoad(), 50);
    loader.scrollParent.addEventListener("scroll", loader.scrollHandler, evt3rdArg);
  }
};
</script>
